import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/">CODEDEV</Link>
      </div>
      <div className="nav-links">
        <Link to="/html">HTML</Link>
        <Link to="/css">CSS</Link>
        <Link to="/javascript">JavaScript</Link>
        <Link to="/python">Python</Link>
        <Link to="/mysql">MySQL</Link>
        <Link to="/git">Git</Link>
      </div>
      <div className="nav-buttons">
        <button className="btn btn-outline">Sign Up</button>
        <button className="btn btn-primary">Log in</button>
      </div>
    </nav>
  );
};

export default Navbar;
